// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/theme.css
// module id = 1296
// module chunks = 32